<script>
    import { createEventDispatcher } from "svelte";

    export let x = 0;
    export let y = 0;
    export let val = null;
    export let solution = null;
    export let pens = [false, false, false, false, false, false, false, false, false];
    export let selected = null;
    export let high = false;
    export let orig = false;

    const dispatch = createEventDispatcher();

</script>

<g transform="translate({x}, {y})" 
    class:high={high}
    class:sel={selected === val}
    class:err={val !== null && val !== solution}
    class:orig={orig}>
    <rect class="cell" on:click={()=>dispatch("click")} />
    {#if val !== null}
        <text class="num">{val + 1}</text>
    {:else}
        {#if pens[0]}<text class="pen" x="0.05" y="0.30" class:sel={selected == 0}>1</text>{/if}
        {#if pens[1]}<text class="pen" x="0.38" y="0.30" class:sel={selected == 1}>2</text>{/if}
        {#if pens[2]}<text class="pen" x="0.71" y="0.30" class:sel={selected == 2}>3</text>{/if}
        {#if pens[3]}<text class="pen" x="0.05" y="0.63" class:sel={selected == 3}>4</text>{/if}
        {#if pens[4]}<text class="pen" x="0.38" y="0.63" class:sel={selected == 4}>5</text>{/if}
        {#if pens[5]}<text class="pen" x="0.71" y="0.63" class:sel={selected == 5}>6</text>{/if}
        {#if pens[6]}<text class="pen" x="0.05" y="0.96" class:sel={selected == 6}>7</text>{/if}
        {#if pens[7]}<text class="pen" x="0.38" y="0.96" class:sel={selected == 7}>8</text>{/if}
        {#if pens[8]}<text class="pen" x="0.71" y="0.96" class:sel={selected == 8}>9</text>{/if}
    {/if}
</g>

<style>
    .cell {
        stroke-width: 0.05px;
        width: 1px;
        height: 1px;
        fill: rgba(0,0,0,0);
    }
    text.num {
        font-size: 0.7px;
        transform: translate(0.5px, 0.75px);
        text-anchor: middle;
        opacity: 1;
        animation: opacity_animation 1s;
    }
    text.pen {
        font-size: 0.3px;
        opacity: 1;
        animation: opacity_animation 1s;
    }
    @keyframes opacity_animation {
        from {opacity: 0;}
        to {opacity: 1;}
    }

</style>
